import React from 'react';

// eslint-disable-next-line react/prop-types
const App = ({ children }) => {
  return <div>{children}</div>;
};

export default App;
